module.exports = __webpack_public_path__ + "static/media/inviteConsole.664dc200.png";